module.exports = __webpack_public_path__ + "img/lead-9z.4742d0ea.png";